import DatasetCard from './DatasetCard.js';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import './DatasetCardGrid.css';

function DatasetCardGrid(props) {
    const { metadata } = props;
    const chartMetadata = metadata.filter((metaObj) => metaObj['datawrapperLink'] !== undefined);
    return (
        <Row xs={1} sm={1} md={1} lg={2} xl={2} xxl={3}
            style={{
                background: '#E5E5E5', paddingTop: '1em', 
                paddingBottom: '1em', paddingLeft: '6px',
                paddingRight: '6px'
            }}
        >
            {chartMetadata.map((metaObj, idx) => (
                <Col key={idx} style={{paddingLeft: "6px", paddingRight: "6px", height: '100%'}}>
                    <DatasetCard key={idx} metadataObject={metaObj}/>
                </Col>
            ))}
        </Row>
    )
}


export default DatasetCardGrid;